import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuComponent } from './menu-component/menu-component';
import { Banner1Component } from './banner1-component/banner1-component';
import { SupportComponent } from './support-component/support-component';
import { FooterComponent } from './footer-component/footer-component';
import { PublishComponent } from './publish-component/publish-component';
import { Banner2Component } from './banner2-component/banner2-component';
import { FAQComponent } from './faqcomponent/faqcomponent';
import { TierFeaturesComponent } from './tier-features-component/tier-features-component';
import { HIPPAComponent } from './hippacomponent/hippacomponent';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MenuComponent,
    Banner1Component,
    Banner2Component,
    SupportComponent,
    FooterComponent,
    PublishComponent,
    FAQComponent,
    TierFeaturesComponent,
    HIPPAComponent,
  ],
  exports:[
    MenuComponent,
    Banner1Component,
    Banner2Component,
    SupportComponent,
    FooterComponent,
    PublishComponent,
    FAQComponent,
    TierFeaturesComponent,
     HIPPAComponent,
  ]
})
export class LayoutModule { }
